import templateSelection from '../../../../Template/config/components/selection'
import metadataSlice from './MetadataSlice'
import setBuilder from './SetBuilder'
import search from './Search'

export default {
    ...templateSelection,
    metadataSlice,
    setBuilder,
    search
}



// WEBPACK FOOTER //
// ./src/app/configuration/CapitalOne/config/components/selection/index.js